import React from 'react'

import { TooltipProvider } from '@/components/ui/tooltip'
import AppConfigContext from '@/contexts/AppConfigContext'
import { routeTree } from '@/routeTree.gen'
import getAppConfig from '@/utils/getAppConfig'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import ReactDOM from 'react-dom/client'

import '@/styles/globals.css'

// Create a new router instance
const router = createRouter({ routeTree })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')!

const appConfig = getAppConfig()

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <AppConfigContext.Provider value={appConfig}>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </AppConfigContext.Provider>
    </React.StrictMode>,
  )
}
